module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-react-next/~/core-js/modules/_iterators.js
// module id = ./node_modules/gatsby-plugin-react-next/node_modules/core-js/modules/_iterators.js
// module chunks = 168707334958949